export enum ColumnName {
  ONE = 'Un',
  TWO = 'Deux',
  THREE = 'Trois',
}

export const getColumnNameValues = () => Object.values(ColumnName) as [string, ...string[]];
